/**
 * Panel shape definitions for irregular/non-rectangular panels.
 * Each shape provides a CSS clip-path (polygon/circle/ellipse) that is applied to the cell.
 */

export const PANEL_SHAPES = [
  {
    key: "rectangle",
    label: "Rectangle",
    clipPath: null, // no clip - default
  },
  {
    key: "circle",
    label: "Circle",
    clipPath: "circle(50% at 50% 50%)",
  },
  {
    key: "ellipse",
    label: "Ellipse",
    clipPath: "ellipse(50% 45% at 50% 50%)",
  },
  {
    key: "diamond",
    label: "Diamond",
    clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)",
  },
  {
    key: "diagonal_left",
    label: "Diagonal Left",
    clipPath: "polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%)",
  },
  {
    key: "diagonal_right",
    label: "Diagonal Right",
    clipPath: "polygon(0% 0%, 90% 0%, 100% 100%, 10% 100%)",
  },
  {
    key: "hexagon",
    label: "Hexagon",
    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
  },
  {
    key: "trapezoid",
    label: "Trapezoid",
    clipPath: "polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)",
  },
  {
    key: "pentagon",
    label: "Pentagon",
    clipPath: "polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)",
  },
  {
    key: "star",
    label: "Star",
    clipPath: "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
  },
];

export const findPanelShape = (key) => {
  return PANEL_SHAPES.find((s) => s.key === key) || PANEL_SHAPES[0];
};
